export default __webpack_public_path__ + "static/media/vehicle.1574a631b6acbbd3dafd09da79134cb4.svg";